/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _str from "shared/util/_str";
import Context from "shared/util/Context";
import isEqual from "lodash/isEqual";

/*

	How this view works:

	There's a list of predefined property names. They're properties of the model,
	and they're in the dom, in elements where the class is the property name.

	So during each render cycle, check those predefined properties for changes,
	and update the dom where they're changed.

*/
window.BoostView = {
	datalist: [
			"state",
			"tokens",
			"starttime",
			"endtime",
			"percentage",
			"mins",
			"secs",
			"isbonus",
			"viewers",
			"lastpromoimpressions",
			"isopen",
			"isautoboost",
			"next_autoboost",
			"autoboost_viewers",
			"autoboost_time",
			"active_slide",
		],

	bundle: {},

	init() {
		// shorties
		this.Model = BoostModel;
		this.Dom = BoostDom;
		this.Controller = BoostController;
	},

	forceRender() {
		this.render({ ...this.Model.data });
	},

	render(bundle) {
		// Any quick fixes that don't really belong in the update loop
		// ----------------------------------------------------------------------

		// highlight selected boost package
		const tokenpackage = this.Model.get("tokenpackage");
		if (tokenpackage !== "") {
			const checkbox = $(`#${tokenpackage}`).closest("li");

			if (checkbox.length && !checkbox.hasClass("selected")) {
				this.Dom.tokenpackages.removeClass("selected");
				checkbox.addClass("selected");
			}
		}


		// The update loop
		// ----------------------------------------------------------------------

		this.renderModelData(bundle);
	},

	renderModelData(bundle) {
		for (let dataname in bundle) {
			const value = bundle[dataname];

			if (isEqual(this.bundle[dataname], value)) {
				continue;
			}

			// make updates!
			switch (dataname) {
				case "state":
					this.Dom.container.removeClass(this.Model.states.join(" ")).addClass(value);
					this.Dom.activity.removeClass(this.Model.states.join(" ")).addClass(value);

					// hide leaderboards while running
					if (value === "running") {
						this.Dom.ads.addClass("boosting");
					}
					break;

				case "hasBoostSub":
					if (value) {
						this.Dom.panel.removeClass("panel-boost--showsubpromo");
						this.Dom.modal.removeClass("selectboosts--showsubpromo");
					}
					break;

				case "showBoostError":
					if (value && !PageState.get("sawBoostSuccess")) {
						FeedbackBanner.open({
							message: "We couldn’t process your PayPal payment, please let us know!",
							type: "error"
						});
					}
					break;

				case "showBoostSuccess":
					if (value && !PageState.get("sawBoostSuccess")) {
						Modal.open("boost_purchase_success");
					} else {
						Modal.close("boost_purchase_success");
					}
					break;

				case "showBoostSubPromo":
					if (value) {
						this.Dom.panel.addClass("panel-boost--showsubpromo");
						this.Dom.modal.addClass("selectboosts--showsubpromo");
					}
					break;

				case "boostSubsGoAgain":
					if (value) {
						this.Dom.panel.addClass("panel-boost--goagain");
					}
					break;

				case "boostSubsPromoOnly":
					if (value) {
						this.Dom.panel.addClass("panel-boost--promoonly");
					}
					break;

				// switching from package view to subs view or vice versa
				case "showBoostSubs":
					this.Dom.modal.removeClass("selectboosts--pkgs selectboosts--subs");
					if (value) {
						this.Dom.modal.addClass("selectboosts--subs");
					} else {
						this.Dom.modal.addClass("selectboosts--pkgs");
					}
					break;

				case "activeSlide":
					if ((value == null)) { return; }

					var slideClassPrefix = "selectboosts-item--active-slide-";
					var buttonClassPrefix = ".selectboosts-item--slide-controller-button";

					// clear old values
					$(buttonClassPrefix).removeClass("active");

					for (let i = 0; i <= 10; i++) {
						this.Dom.modal_slide_wrapper.removeClass(`${slideClassPrefix}${i}`);
					}

					// set new values
					this.Dom.modal_slide_wrapper.addClass(`${slideClassPrefix}${value}`);
					$(`${buttonClassPrefix}[data-slide-index=${value}]`).addClass("active");
					break;

				case "percentage":
					this.Dom.progress_bar.css("width", value + "%");
					break;

				case "isbonus":
					if (value) {
						this.Dom.container.addClass("hasbonus");
					} else {
						this.Dom.container.removeClass("hasbonus");
					}
					break;

				case "isautoboost":
					if (value) {
						this.Dom.activity.addClass("autoboost");

					} else {
						this.Dom.activity.removeClass("autoboost");
					}
					break;

				case "autoboost_viewers":
					if (value) {
						this.Dom.autoboost.show().find(".autoboost_imps").html(value);
					} else {
						this.Dom.autoboost.hide();
					}
					break;

				case "autoboost_time":
					if (value && (value !== "") && this.Dom.autoboost.find(".autoboost_time").length) {
						const boost_time = jQuery(`<span id=\"promo_${value}\"></span>`);
						this.Dom.autoboost.show().find(".autoboost_time").html(boost_time);
						FancyDate.add(boost_time.attr("id"), value, "AUTOBOOST_TIMES");
					} else {
						this.Dom.autoboost.hide();
					}
					break;

				case "tokens":
					this.Dom.button_open_text.text(value || _str("Boost"));
					if (this.Dom.button_usernav_open_text != null ? this.Dom.button_usernav_open_text.length : undefined) {
						this.Dom.button_usernav_open_text.toggle(!!value);
						this.Dom.button_usernav_open_text.html(value);
					}
					break;

				// default update behavior
				default:
					this.Dom.container.find(`.${dataname}`).html(value);
			}

			// Set tooltip text
			this.Dom.button_open.attr('data-tooltip', this.Model.calculateTooltipText());

			// update the local copy
			this.bundle[dataname] = value;
		}
	}
};



// WEBPACK FOOTER //
// ./src/legacy/boosts/view.js